import React from 'react';
import '../crm.css';

const TEMPLATE_OPTIONS = [
    { value: 'intro', label: 'Intro' },
    { value: 'options', label: 'Share options' },
    { value: 'confirm', label: 'Confirm site visit' },
];

function SmartActionsBar({
    entityType,
    entityId,
    lead,
    onCall,
    onWhatsApp,
    onEmail,
    onScheduleFollowUp,
    onScheduleSiteVisit,
    onMarkContacted,
    onTemplateSelect,
    className = '',
    disabledReason,
}) {
    const isLinked = Boolean(entityId);
    const phone = lead?.phone || lead?.mobile || lead?.meta?.phone || '';
    const email = lead?.email || lead?.meta?.email || '';
    const linkReason = disabledReason || 'Link an entity to enable';

    const disableAll = !isLinked;
    const callDisabled = disableAll || !phone || !onCall;
    const whatsappDisabled = disableAll || !phone || !onWhatsApp;
    const emailDisabled = disableAll || !email || !onEmail;
    const followupDisabled = disableAll || !onScheduleFollowUp;
    const siteVisitDisabled = disableAll || !onScheduleSiteVisit;
    const markContactedDisabled = disableAll || !onMarkContacted;
    const templatesDisabled = disableAll || !phone || !onTemplateSelect;

    const resolveTitle = (disabled, fallback) => (disabled ? fallback : undefined);

    return (
        <div className={`crm-action-grid ${className}`}>
            <button
                className="crm-btn crm-btn-secondary crm-btn-sm"
                type="button"
                onClick={onCall}
                disabled={callDisabled}
                title={resolveTitle(callDisabled, disableAll ? linkReason : 'Add phone to enable')}
                data-entity={entityType}
            >
                Call
            </button>
            <div className="crm-inline-field">
                <button
                    className="crm-btn crm-btn-secondary crm-btn-sm"
                    type="button"
                    onClick={onWhatsApp}
                    disabled={whatsappDisabled}
                    title={resolveTitle(whatsappDisabled, disableAll ? linkReason : 'Add phone to enable')}
                    data-entity={entityType}
                >
                    WhatsApp
                </button>
                <select
                    className="crm-select crm-select-sm"
                    defaultValue=""
                    disabled={templatesDisabled}
                    title={resolveTitle(templatesDisabled, disableAll ? linkReason : 'Add phone to enable')}
                    onChange={(event) => {
                        const value = event.target.value;
                        if (value && onTemplateSelect) {
                            onTemplateSelect(value);
                        }
                        event.target.value = '';
                    }}
                >
                    <option value="">Templates</option>
                    {TEMPLATE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            <button
                className="crm-btn crm-btn-secondary crm-btn-sm"
                type="button"
                onClick={onEmail}
                disabled={emailDisabled}
                title={resolveTitle(emailDisabled, disableAll ? linkReason : 'Add email to enable')}
                data-entity={entityType}
            >
                Email
            </button>
            <button
                className="crm-btn crm-btn-primary crm-btn-sm"
                type="button"
                onClick={onScheduleFollowUp}
                disabled={followupDisabled}
                title={resolveTitle(followupDisabled, linkReason)}
                data-entity={entityType}
            >
                Schedule Follow-up
            </button>
            <button
                className="crm-btn crm-btn-secondary crm-btn-sm"
                type="button"
                onClick={onScheduleSiteVisit}
                disabled={siteVisitDisabled}
                title={resolveTitle(siteVisitDisabled, linkReason)}
                data-entity={entityType}
            >
                Schedule Site Visit
            </button>
            <button
                className="crm-btn crm-btn-secondary crm-btn-sm"
                type="button"
                onClick={onMarkContacted}
                disabled={markContactedDisabled}
                title={resolveTitle(markContactedDisabled, linkReason)}
                data-entity={entityType}
            >
                Mark Contacted
            </button>
        </div>
    );
}

export default SmartActionsBar;
